// Date helpers for the Buyer Insights tabs. Dates travel as 'YYYY-MM-DD' strings (Europe/Amsterdam
// calendar days on the server); we never call toISOString(), which would shift local midnight to UTC.
import { differenceInCalendarDays, format, parse, parseISO, startOfDay, subDays } from 'date-fns';

export const toYmd = (d) => format(d, 'yyyy-MM-dd');
export const fromYmd = (s) => parse(s, 'yyyy-MM-dd', new Date());

export const yesterdayYmd = (today = new Date()) => toYmd(subDays(startOfDay(today), 1));

// "Last N weeks" ending on endYmd, inclusive: N*7 days.
export const presetRange = (weeks, endYmd) => ({
  start: toYmd(subDays(fromYmd(endYmd), weeks * 7 - 1)),
  end: endYmd,
});

const maxYmd = (a, b) => (a > b ? a : b);
const minYmd = (a, b) => (a < b ? a : b);

// Keep a window inside the server's bounds; never let start pass end.
export const clampWindow = ({ start, end }, { min_start, max_end }) => {
  let s = min_start ? maxYmd(start, min_start) : start;
  let e = max_end ? minYmd(end, max_end) : end;
  if (s > e) s = e;
  return { start: s, end: e };
};

export const formatDate = (ymd) => (ymd ? format(fromYmd(ymd), 'd MMM') : '');
export const formatDateLong = (ymd) => (ymd ? format(fromYmd(ymd), 'd MMM yyyy') : '');
export const formatRange = (s, e) => `${formatDate(s)} – ${formatDate(e)}`;

export const daysSince = (iso, today = new Date()) => differenceInCalendarDays(today, parseISO(iso));
